@if (!hasSubscription() && trialInfo()?.trialEndDate) {
  @if (variant() === 'caption') {
    <div
      class="flex flex-col items-center whitespace-nowrap rounded-2xl bg-background-white px-4 py-2 text-center text-text-tertiary shadow-modal"
      data-testid="assistant-trial-badge-root"
    >
      <span class="typo-h8-light">{{ 'assistant_trial_badge_caption_prefix' | translate }}</span>
      <span class="typo-h8-semibold">{{ 'assistant_trial_badge_caption_days' | translate: { input1: trialDaysRemaining() } }}</span>
    </div>
  } @else {
    <div
      class="typo-h7-medium flex h-4 items-center whitespace-nowrap rounded bg-background-light-grey px-1.5 text-text-secondary"
      data-testid="assistant-trial-badge-root"
    >
      {{ 'assistant_trial_badge_label' | translate: { input1: trialDaysRemaining() } }}
    </div>
  }
}
